import { TeamManagement } from '@/components/team/TeamManagement';

export default function BackOfficeUsers() {
  return <TeamManagement showHeader={true} />;
}
